import SvgCustoms from "../../../../components/main/wrappers/svg-customs/SvgCustoms";

import { ReactComponent as Church_2_1 } from "../../../../static/images/contents/zone-5/icons/2/church_1.svg";
import { ReactComponent as Church_2_2 } from "../../../../static/images/contents/zone-5/icons/2/church_2.svg";
import { ReactComponent as Church_2_3 } from "../../../../static/images/contents/zone-5/icons/2/church_3.svg";
import { ReactComponent as Church_2_4 } from "../../../../static/images/contents/zone-5/icons/2/church_4.svg";
import { ReactComponent as Church_2_5 } from "../../../../static/images/contents/zone-5/icons/2/church_5.svg";
import { ReactComponent as Hospital_2_1 } from "../../../../static/images/contents/zone-5/icons/2/hospital_1.svg";
import { ReactComponent as School_2_1 } from "../../../../static/images/contents/zone-5/icons/2/school_1.svg";
import { ReactComponent as School_2_2 } from "../../../../static/images/contents/zone-5/icons/2/school_2.svg";
import { ReactComponent as School_2_3 } from "../../../../static/images/contents/zone-5/icons/2/school_3.svg";
import { ReactComponent as Museum_2_1 } from "../../../../static/images/contents/zone-5/icons/2/museum_1.svg";
import { ReactComponent as Museum_2_2 } from "../../../../static/images/contents/zone-5/icons/2/museum_2.svg";

import { ReactComponent as Church_33_1 } from "../../../../static/images/contents/zone-5/icons/33/church_1.svg";
import { ReactComponent as Church_33_2 } from "../../../../static/images/contents/zone-5/icons/33/church_2.svg";
import { ReactComponent as Church_33_3 } from "../../../../static/images/contents/zone-5/icons/33/church_3.svg";
import { ReactComponent as Church_33_4 } from "../../../../static/images/contents/zone-5/icons/33/church_4.svg";
import { ReactComponent as School_33_1 } from "../../../../static/images/contents/zone-5/icons/33/school_1.svg";
import { ReactComponent as School_33_2 } from "../../../../static/images/contents/zone-5/icons/33/school_2.svg";
import { ReactComponent as School_33_3 } from "../../../../static/images/contents/zone-5/icons/33/school_3.svg";
import { ReactComponent as Museum_33_2 } from "../../../../static/images/contents/zone-5/icons/33/museum_2.svg";

import { ReactComponent as Church_61_1 } from "../../../../static/images/contents/zone-5/icons/61/church_1.svg";
import { ReactComponent as Church_61_2 } from "../../../../static/images/contents/zone-5/icons/61/church_2.svg";
import { ReactComponent as Church_61_4 } from "../../../../static/images/contents/zone-5/icons/61/church_4.svg";
import { ReactComponent as School_61_1 } from "../../../../static/images/contents/zone-5/icons/61/school_1.svg";
import { ReactComponent as School_61_2 } from "../../../../static/images/contents/zone-5/icons/61/school_2.svg";
import { ReactComponent as School_61_3 } from "../../../../static/images/contents/zone-5/icons/61/school_3.svg";
import { ReactComponent as Museum_61_2 } from "../../../../static/images/contents/zone-5/icons/61/museum_2.svg";

import { ReactComponent as Church_91_1 } from "../../../../static/images/contents/zone-5/icons/91/church_1.svg";
import { ReactComponent as Church_91_2 } from "../../../../static/images/contents/zone-5/icons/91/church_2.svg";
import { ReactComponent as Church_91_4 } from "../../../../static/images/contents/zone-5/icons/91/church_4.svg";
import { ReactComponent as School_91_1 } from "../../../../static/images/contents/zone-5/icons/91/school_1.svg";
import { ReactComponent as School_91_2 } from "../../../../static/images/contents/zone-5/icons/91/school_2.svg";
import { ReactComponent as School_91_3 } from "../../../../static/images/contents/zone-5/icons/91/school_3.svg";
import { ReactComponent as Museum_91_2 } from "../../../../static/images/contents/zone-5/icons/91/museum_2.svg";

export const zone5_landmarks = [
    {
        index: 2,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Hospital_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Museum_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Museum_2_2,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 33,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_33_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_33_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_33_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_33_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_33_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_33_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_33_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Museum_33_2,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 61,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_61_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_61_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_61_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_61_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_61_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_61_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Museum_61_2,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 91,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Museum_91_2,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
];
